export default "__VITE_ASSET__a08a95be__"